import React from "react";
import { Link } from "react-router";
import * as appRouting from "appRouting";
import AuthFooter from "user/authentication/ui/views/components/AuthFooter";
const AuthAlreadyHasPassword = () => {
    return (React.createElement(AuthFooter, null,
        "Already have an account? ",
        React.createElement(Link, { to: appRouting.loginPath() }, "Sign In")));
};
export default AuthAlreadyHasPassword;
